import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  public static init(): void {
    const gtmCfg = environment.gtm;

    if (!gtmCfg || !gtmCfg.id || !gtmCfg.auth || !gtmCfg.preview) {
      console.warn('Google Tag Manager is missing configuration, it will not be initialized.');
      return;
    }

    // Initialize data layer.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Create script element and append it to DOM.
    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtm.js?' +
      `id=${gtmCfg.id}` +
      `&gtm_auth=${gtmCfg.auth}` +
      `&gtm_preview=${gtmCfg.preview}` +
      `&gtm_cookies_win=x`;

    document.head.appendChild(script);
  }
}
